export default "__VITE_ASSET__DkdAh6ml__"